// Text an admin can paste straight into Teams or Jira. The link is built from
// the admin route path (/admin/conversation/:conversationId) rather than a
// stored URL, so a pasted link always points at the environment the admin is
// looking at and survives a change of host.
import type { ConversationSummary } from "../types";

/** Absolute deep link to the admin detail page for one conversation. */
export function conversationDeepLink(conversationId: string, origin: string): string {
  return `${origin}/admin/conversation/${encodeURIComponent(conversationId)}`;
}

/** The shareable block of conversation identifiers: id, user and deep link. */
export function conversationShareText(
  conversation: Pick<ConversationSummary, "conversation_id" | "username">,
  origin: string
): string {
  return [
    `Conversation ID: ${conversation.conversation_id}`,
    `User: ${conversation.username}`,
    `Link: ${conversationDeepLink(conversation.conversation_id, origin)}`,
  ].join("\n");
}
